<template>
  <!-- 大额申请选择 -->
  <a-modal
    :title="title"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    :footer="null"
    width="60%"
    centered
    @cancel="handleCancel"
    :dialog-style="{ top: '4px' }"
  >
    <div class="contentdiv">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="tableLoadding"
        :pagination="tablePagination"
        :rowKey="(record,index)=>{return index}"
        :size="tableSize"
        @change="pageChange"
        bordered
        class="tableClass"
      >
        <template slot="project" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ record.project }}</template>
            <span @click="openView(record, 'project')" class="onClickStyle">{{record.project}}</span>
          </a-tooltip>
        </template>
        <template slot="opportunityTitle" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">{{record.opportunityTitle}}</template>
            <span
              @click="openView(record, 'salesOpportunities')"
              class="onClickStyle"
            >{{record.opportunityTitle}}</span>
          </a-tooltip>
        </template>
        <template slot="customerName" slot-scope="text, record">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ record.customerName }}</template>
            <span
              @click="openView(record, 'customerName')"
              class="onClickStyle"
            >{{record.customerName}}</span>
          </a-tooltip>
        </template>
        <template slot="amount" slot-scope="text, record">
          <span
            v-if="record.amount"
          >￥{{ parseFloat(record.amount).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        </template>
        <template slot="oherOperation" slot-scope="text, record">
          <span
            style="color:#1890ff; margin-right: 10px; cursor: pointer;"
            @click="handleChange(record)"
          >选择</span>
        </template>
      </a-table>
      <copy-drawer
        ref="publicDrawerRef"
        :title="publicDrawer.title"
        :dialog-visible="publicDrawer.visible"
        :component-name="publicDrawer.comName"
        @projectChanges="projectChanges"
        @close="publicDrawerClose"
      />
      <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
    </div>
  </a-modal>
</template>

<script>
// import moment from 'moment'
import clickView from '@/components/view/clickView.vue'
import copyDrawer from '../../../components/drawer/copyDrawer.vue'

export default {
  name: 'LargeAmountApplication',
  components: { copyDrawer, clickView },
  props: {
    title: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    currentDecimalDetailList: {
      type: String,
      default: ''
    },
    beforeDecimalDetailList: {
      type: String,
      default: ''
    },
    reimbursementMethod: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      columns: [
        {
          title: 'ID',
          ellipsis: true,
          dataIndex: 'id',
          sorter: (a, b) => a.id - b.id,
          align: 'center'
        },
        {
          title: '对应项目',
          dataIndex: 'project',
          ellipsis: true,
          scopedSlots: { customRender: 'project' }
        },
        {
          title: '对应销售机会',
          dataIndex: 'opportunityTitle',
          ellipsis: true,
          scopedSlots: { customRender: 'opportunityTitle' }
        },
        {
          ellipsis: true,
          title: '对应客户/供应商',
          dataIndex: 'customerName',
          scopedSlots: { customRender: 'customerName' }
        },
        {
          ellipsis: true,
          title: '申请人',
          dataIndex: 'peopleName'
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate'
        },
        {
          title: '申请金额',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '操作',
          dataIndex: 'oherOperation',
          align: 'center',
          scopedSlots: { customRender: 'oherOperation' }
        }
      ],
      tableData: [],
      tableLoadding: false,
      tablePagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      tableScroll: { x: 1000, y: 480 },
      tableSize: 'middle',
      publicDrawer: {
        title: '',
        visible: false,
        comName: ''
      },
      clickViewVisible: false,
      character: {
        currentDecimalDetailList: '',
        beforeDecimalDetailList: ''
      }
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.handleCancel()
      }
    }
  },
  mounted () {
    // this.initData()
  },
  methods: {
    initData (params = {}, data = []) {
      // console.log('params', params, data)
      this.tableLoadding = true
      if (params && params.beforeDecimalDetailList) {
        this.$set(this.character, 'beforeDecimalDetailList', params.beforeDecimalDetailList)
        this.$set(this.character, 'currentDecimalDetailList', params.currentDecimalDetailList)
        this.$set(this.character, 'peopleId', params.peopleId)
        this.$set(this.character, 'reimbursementId', params.reimbursementId)
      }
      params.pageSize = this.tablePagination.pageSize
      params.pageNum = this.tablePagination.pageNum
      this.$post('/bigAmount/filterList', params).then(res => {
        if (res.data.status === 1) {
          let resDataList = []
          if (this.reimbursementMethod === 1) {
            resDataList = res.data.data.filter(item => !!item.opportunityId)
          } else {
            resDataList = res.data.data
          }
          // console.log('resDataList', resDataList.length)
          // const resDataList = res.data.data
          var tabledata1 = JSON.parse(JSON.stringify(resDataList))
          this.tablePagination.total = Number(resDataList.length)
          if (data.length) {
            data.forEach(item => {
              this.newTable = tabledata1.filter(e => e.id !== item)
              tabledata1 = JSON.parse(JSON.stringify(this.newTable))
            })
            this.tableData = JSON.parse(JSON.stringify(this.newTable))
          } else {
            this.tableData = resDataList
          }
          setTimeout(() => {
            this.tableLoadding = false
          }, 500)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    pageChange (pageVal) {
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
      this.tablePagination.current = pageVal.current
      this.initData(this.character)
    },
    handleCancel () {
      this.$emit('close')
    },
    // 选择大额申请
    handleChange (data) {
      // console.log('handleChange', data)
      this.$emit('success', data)
    },
    openView (rowVal, name) {
      this.clickViewVisible = true
      if (name === 'purchaseName') {
        this.$refs.clickViewRef.openView('purchase', rowVal, rowVal.purchaseId)
      } else if (name === 'customerName') {
        this.$refs.clickViewRef.openView('customer', rowVal, rowVal.customerId)
      } else if (name === 'project') {
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.projectId)
      } else if (name === 'contractName') {
        this.$refs.clickViewRef.openView('contract', rowVal, rowVal.contractId)
      } else if (name === 'salesOpportunities') {
        this.$refs.clickViewRef.openView('salesOpportunities', rowVal, rowVal.opportunityId)
      }
    },
    projectChanges (value, name) {
      // this.publicDrawer.visible = false
      if (name === 'project') {
        this.$get('/project/list', { id: value.projectId }).then(res => {
          // this.projectInfo = res.data.data.rows[0]
          if (res.data.data.rows && res.data.data.rows.length > 0) {
            this.openView(res.data.data.rows[0], 'project')
          } else {
            this.$message.warning('未查询到该数据，可能已删除或者没有操作权限，请检查！', 5)
          }
        })
      }
      if (name === 'customerName') this.openView(value, name)
      if (name === 'purchaseName') this.openView(value, name)
      if (name === 'contractName') this.openView(value, name)
      if (name === 'salesOpportunities') this.openView(value, name)
    },
    publicDrawerClose () { // 公共抽屉关闭
      this.publicDrawer = {
        title: '',
        visible: false,
        comName: ''
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.largeAmountApplication {
  width: 100%;
  .contentdiv {
    margin-top: 20px;
  }
}
.tableClass {
  /deep/ .ant-table-pagination.ant-pagination {
    margin: 10px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/financialManage/expenseReim/select.vue